import {logger} from 'yougile-util'

const SHARED_KEYS = new Set([
  'card_id',
  'data-init',
  'guest-id',
  'guest-key',
  'state'
])

export const lastSeenBoardKey = 'lastSeenBoard'
export const collapsedHeaderKey = 'collapsedHeader'
export const showMoreDeleteTaskKey = 'deleteTask'
export const wasLicenseWarningShownKey = 'wasLicenseWarningShown'

const isSharedKey = (key: string) => {
  return SHARED_KEYS.has(key) || key?.startsWith('y-init::')
}

export class Storage {
  public static getSharedId(): string | undefined {
    return location?.pathname.match(/\/board\/([a-z0-9]+)/)?.[1]
  }

  private static prefix = Storage.getSharedId()
    ? 'board=' + Storage.getSharedId() + ':'
    : ''

  private static fullKey(key: string): string {
    return isSharedKey(key) ? key : Storage.prefix + key
  }

  public static getWithoutPrefix(key: string): string | undefined {
    return localStorage.getItem(key) ?? undefined
  }

  public static getItem(key: string): string | undefined {
    return localStorage.getItem(Storage.fullKey(key)) ?? undefined
  }

  public static getItemAsJson<T>(key: string): T | undefined {
    try {
      const value = Storage.getItem(key)
      return value ? (JSON.parse(value) as T) : undefined
    } catch (e) {
      return undefined
    }
  }

  public static setItem(key: string, value: string): void {
    localStorage.setItem(Storage.fullKey(key), value)
  }

  public static setItemAsJson<T>(key: string, value: T): void {
    Storage.setItem(key, JSON.stringify(value))
  }

  public static removeItem(key: string): void {
    localStorage.removeItem(Storage.fullKey(key))
  }

  public static subscribe(listener: (e: StorageEvent) => void): () => void {
    window.addEventListener('storage', listener)
    return () => window.removeEventListener('storage', listener)
  }
}

export const getSafeObjFromLocalStorage = <T extends {[key: string]: unknown}>(
  key: string
): T => {
  try {
    return JSON.parse(localStorage.getItem(key) || '{}')
  } catch (e) {
    return {} as T
  }
}

export const saveSafeObjToLocalStorage = (key: string, obj: unknown): void => {
  if (!obj) {
    logger.warn('u$ no object to save to localStorage')
    return
  }

  try {
    return localStorage.setItem(key, JSON.stringify(obj))
  } catch (e) {
    return
  }
}
